export const SET_MENU_SEARCH_QUERY = 'menuSearch/SET_MENU_SEARCH_QUERY'
